module.exports = __webpack_public_path__ + "static/media/umd.dd41b79d.png";